import React from 'react';

import InformationPagesView from 'views/information_module/informationPagesView/InformationPagesView';
import Error from 'components/shared/Error';

import {
  ESSENTIALS_IDENTIFIERS,
  INFO_PAGES_TYPES,
  ESSENTIALS_URLS,
} from 'views/information_module/utils/Constants';

import isCrawlers from 'common/utils/isCrawlers';
import generateHreflang from 'utils/generateHreflang';
import { serverFetch } from 'utils/serverFetch';
import { API } from 'config/axios';

const MotorcycleRentalLicenseRequirements = (props) => {
  const {
    infoPageType, infoPageIdentifier, serverData, errorStatusCode, preferredSeoIdentifer,
  } = props;

  if (errorStatusCode) {
    return <Error statusCode={errorStatusCode || 500} />;
  }
  return (
    <InformationPagesView
      infoPageType={infoPageType}
      infoPageIdentifier={infoPageIdentifier}
      serverData={serverData}
      preferredSeoIdentifer={preferredSeoIdentifer}
    />
  );
};

MotorcycleRentalLicenseRequirements.getInitialProps = async (ctx) => {
  let serverData;
  const infoPageIdentifier = ESSENTIALS_IDENTIFIERS.motorcycle_rental_license_requirements;
  const infoPageType = INFO_PAGES_TYPES.essentials;
  const preferredSeoIdentifer = ESSENTIALS_URLS.motorcycle_rental_license_requirements;

  let errorStatusCode;

  const ssrRender = ctx.req ? isCrawlers(ctx.req.headers['user-agent']) : false;
  if (ssrRender) {
    const { success, data, error } = await serverFetch(ctx, API.informationPages, {
      identifier: infoPageIdentifier,
      preferred_seo_identifer: preferredSeoIdentifer,
    });
    if (success && data) {
      serverData = data;
    } else {
      switch (error?.response && error.response.status) {
        case 404:
          errorStatusCode = error.response.status;
          ctx.res.statusCode = error.response.status;
          break;
        default:
          ctx.res.statusCode = 502;
          ctx.res.end();
          break;
      }
    }
  }

  // generate canonical and hrefLang
  const host = ctx.req ? ctx.req.headers.host : window.location.host;
  let url;
  if (ctx.req) {
    url = ctx.req.url;
  } else {
    url = ctx.asPath;
  }

  const headLinks = generateHreflang(url, '/motorcycle-rental-license-requirements', host);

  return {
    namespacesRequired: ['fe_es_information_pages', 'routes'],
    serverData,
    headLinks,
    ssrRender,
    infoPageType,
    infoPageIdentifier,
    errorStatusCode,
    preferredSeoIdentifer,
  };
};

export default MotorcycleRentalLicenseRequirements;
